/**
 * Admin page: Global-e merchant migration tools and related portal actions.
 */
import { observer } from "mobx-react-lite";
import React from "react";
import BasePageLayout from "../../../components/layouts/base-page-layout/base-page-layout";
import EditorPageLayout from "../../../components/layouts/editor-page/editor-page-layout";
import MigrateGlobalePlatformCard from "./migrate-globale-platform-card";
import MigrateGlobaleShopifyPlatformCard from "./migrate-globale-shopify-platform-card";
import ActivateGlobaleStoreCard from "./activate-globale-store-card";
import DownloadOpenRmasCard from "./download-open-rmas-card";

const AdminMigrateGlobalEMerchants: React.FC = observer(() => {

    return (
            <BasePageLayout title="Migrate Global-E Merchants">
                <EditorPageLayout
                    toolbar={{
                        hasBack: false,
                        hasLocalesSelector: false,
                    }}
                >

                    <div className='migrate-global-e-merchants'>

                        <MigrateGlobalePlatformCard />
                        <MigrateGlobaleShopifyPlatformCard />
                        <ActivateGlobaleStoreCard />
                        <DownloadOpenRmasCard />
                    </div>

                </EditorPageLayout>
            </BasePageLayout>
    );
});

export default AdminMigrateGlobalEMerchants;
